import { Box, InputAdornment, TextField } from "@mui/material";
import { SharedFieldInputProps } from "./types";

const normalizeColor = (value: string | null | undefined) => {
    const normalized = String(value || "").trim();
    return /^#[0-9a-fA-F]{6}$/.test(normalized) ? normalized : "";
};

interface ColorPickerFieldInputProps extends SharedFieldInputProps<string | null> {}

export function ColorPickerFieldInput({
    value,
    onChange,
    error = false,
    helperText,
    autoFocus = false,
    fullWidth = true,
    size = "small",
    disabled = false,
}: ColorPickerFieldInputProps) {
    const colorValue = normalizeColor(value) || "#000000";

    const handleTextChange = (nextValue: string) => {
        const valueWithHash = nextValue.startsWith("#") ? nextValue : `#${nextValue}`;
        onChange(valueWithHash.toUpperCase());
    };

    return (
        <TextField
            value={value ?? ""}
            onChange={(event) => handleTextChange(event.target.value)}
            error={error}
            helperText={helperText}
            autoFocus={autoFocus}
            fullWidth={fullWidth}
            size={size}
            disabled={disabled}
            placeholder="#D71920"
            inputProps={{ maxLength: 7 }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <Box
                            component="input"
                            type="color"
                            value={colorValue}
                            disabled={disabled}
                            onChange={(event) => onChange(event.target.value.toUpperCase())}
                            sx={{
                                width: 32,
                                height: 28,
                                p: 0,
                                border: "1px solid",
                                borderColor: "divider",
                                borderRadius: 1,
                                bgcolor: "transparent",
                                cursor: disabled ? "not-allowed" : "pointer",
                            }}
                        />
                    </InputAdornment>
                ),
            }}
        />
    );
}
